import { ChangeDetectionStrategy, Component, computed, input, numberAttribute, Signal } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';

@Component({
  selector: 'tiime-progress-spinner-loader',
  templateUrl: './progress-spinner-loader.component.html',
  styleUrls: ['./progress-spinner-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ProgressSpinnerLoaderComponent {
  readonly color = input<ThemePalette | 'white'>();
  readonly mode = input<ProgressSpinnerMode>(undefined!);
  readonly value = input<number>(undefined!);
  readonly diameter = input(32, {
    transform: numberAttribute
  });

  readonly colorPalette: Signal<ThemePalette | undefined> = computed(() => {
    const color = this.color();
    if (color === 'white') {
      return undefined;
    }
    return color;
  });

  readonly containerSize: Signal<Record<string, number>> = computed(() => {
    return { 'width.px': this.diameter(), 'height.px': this.diameter() };
  });
}
